<cs-standard-form #executeDocumentForm
  label="Run a Command"
  cardClass="document-execution-card"
  text=""
  primaryButtonText="Run"
  (submitted)="executeCommandDocument()"
  (cancelled)="dialogRef.close()"
  [primaryButtonDisabled]="!isFormValid() || executeLoader">

  <!-- Document and Cloud Account -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Command Document</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="row mt-2">
      <div class="col-12 row-display no-padding">
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Cloud Account</mat-label>
            <cs-select name="command-cloud-account"
              preventDeselection
              [multiSelect]="false"
              [options]="cloudAccountOptions"
              [(ngModel)]="commandRequest.cloud_account_id"
              (valueChange)="onDocumentDtlsChange()"
              [readonly]="isSelectionReadOnly"
              required/>
          </mat-form-field>
        </div>
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Region</mat-label>
            <cs-select name="execute-regions"
              preventDeselection
              [multiSelect]="false"
              [options]="regionOptions"
              [(ngModel)]="commandRequest.region"
              (valueChange)="onDocumentDtlsChange()"
              [readonly]="isSelectionReadOnly"
              required/>
          </mat-form-field>
        </div>
        <div class="col-6 document-field-section-align">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Versions</mat-label>
            <mat-hint>Choose the document version you want to run.</mat-hint>
            <cs-select name="document-version"
              preventDeselection
              [options]="versionOptions"
              [(ngModel)]="commandRequest.document_version"
              (ngModelChange)="findVersionRecord()"
              [multiSelect]="false"/>
          </mat-form-field>
        </div>
        <div class="col-6 dsp-flex justify-center">
          <mat-form-field appearance="outline">
            <mat-label class="mat-h5">Change ID</mat-label>
            <input matInput
              autocomplete="off"
              type="text"
              name="commandChangeID"
              placeholder="Change ID"
              maxlength="100"
              [(ngModel)]="commandRequest.change_id"/>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- Parameters -->
  <div class="document-execution--section mt-2">
    @if (!versionRecord?.parameters || versionRecord?.parameters.length == 0) {
      <div>
        <h3 class="mb-1"><strong>Input Parameters </strong></h3>
        <mat-divider class="cs-light-border"></mat-divider>
        @if (versionLoader) {
          <div class="container-width mt-2"
            >
            <div class="execution-container detail-page-card-padding">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        }
        @if (!versionLoader) {
          <div class="col-12 mt-2 no-padding"
            >
            <p class="fnt-lght">No Input Parameters available.</p>
          </div>
        }
      </div>
    }
    @if (!versionLoader && versionRecord?.parameters?.length > 0) {
      <div class="row"
        >
        <div class="col-12 p-0">
          <cs-input-parameters [parameters]="versionRecord.parameters"
            (valueChange)="inputParametersState.formattedModelValue = $event"
            [executionType]="ExecutionType.Command"
            (inputParamValid)="executeDocumentObj.isInpParamsValid = $event"
            [(currentModelValue)]="inputParametersState.currentModelValue"
            (formValidChange)="inputParametersState.valid = $event">
          </cs-input-parameters>
        </div>
      </div>
    }
  </div>

  <!--Target Selection -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Target Selection</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="row">
      <div class="col-12 mt-2">
        <p class="fnt-lght mb-0">Choose a method for selecting the target.</p>
      </div>
      <div class="col-12 mt-2">
        <mat-radio-group name="target-type-option"
          [(ngModel)]="executeDocumentObj.targetType">
          <div class="col-12 row-display flex-center no-padding">
            <div class="execution-type-option"
              [class.active-select]="executeDocumentObj.targetType === CommandTargetType.Tags">
              <label class="dsp-flex">
                <mat-radio-button name="targetTagsSelection"
                  color="primary"
                  [value]="CommandTargetType.Tags"
                  checked
                  class="dsp-flex"
                (click)="resetTargetType()"></mat-radio-button>
                <div class="document-radio-button-option">
                  <h3>Specify instance tags</h3>
                  <p class="mt-1 fnt-lght">Specify one or more tag key-value pairs to select any instances that share those tags.</p>
                </div>
              </label>
            </div>
            <div class="execution-type-option"
              [class.active-select]="executeDocumentObj.targetType === CommandTargetType.Instance">
              <label class="dsp-flex">
                <mat-radio-button name="targetInstanceSelection"
                  color="primary"
                  [value]="CommandTargetType.Instance"
                  (click)="resetTargetType();fetchInstance()"
                class="dsp-flex"></mat-radio-button>
                <div class="document-radio-button-option">
                  <h3>Choose instance manually</h3>
                  <p class="mt-1 fnt-lght">Manually select the instances you want to register as targets.</p>
                </div>
              </label>
            </div>
            <div class="execution-type-option"
              [class.active-select]="executeDocumentObj.targetType === CommandTargetType.ResourceGroup">
              <label class="dsp-flex">
                <mat-radio-button color="primary"
                  name="targetResGroupSelection"
                  [value]="CommandTargetType.ResourceGroup"
                  (click)="resetTargetType();fetchResourceGroup()"
                class="dsp-flex"></mat-radio-button>
                <div class="document-radio-button-option">
                  <h3>Choose a resource group</h3>
                  <p class="mt-1 fnt-lght">Choose a resource group that includes the resources you want to target.</p>
                </div>
              </label>
            </div>
          </div>
        </mat-radio-group>
      </div>
      @if (executeDocumentObj.targetType === CommandTargetType.Tags) {
        <div class="col-12 mt-2"
          >
          <h3 class="mb-0"><strong>Specify instance tags</strong></h3>
          <div class="row">
            <div class="col-12 mt-1">
              <p class="fnt-lght">Specify one or more tag key-value pairs to select any instances that share those tags.</p>
            </div>
            <div class="col-12 row-display mt-1">
              <div class="col-5 no-padding">
                <mat-form-field appearance="outline">
                  <mat-label>Tag Key</mat-label>
                  <input matInput
                    type="text"
                    name="targetObjTagKey"
                    placeholder="Key"
                    minlength="1"
                    maxlength="127"
                    [(ngModel)]="executeDocumentObj.targetObj.tagKey"/>
                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field appearance="outline">
                  <mat-label>Tag Value</mat-label>
                  <input matInput
                    type="text"
                    name="targetObjTagValue"
                    placeholder="Value"
                    minlength="1"
                    maxlength="255"
                    [(ngModel)]="executeDocumentObj.targetObj.tagValue"/>
                </mat-form-field>
              </div>
              <div class="col-2 tag-action">
                <cs-icon-button buttonStyle="tertiary"
                  [disabled]="!executeDocumentObj.targetObj.tagKey"
                  icon="add_circle"
                  (buttonClick)="addTargetTags()"/>
              </div>
            </div>
            <div class="col-md-12 row-display">
              <mat-chip-listbox>
                @for (tagObj of executeDocumentObj.targetObj.tagsList; track tagObj) {
                  <mat-chip class="cs-bg-clr-selected-blue"
                    (removed)="removeTags(tagObj)">
                    <span>{{tagObj.key}}: {{tagObj.value}}</span>
                    <div matChipRemove>
                      <mat-icon fontSet="cs-icon"
                      fontIcon="cs-icon-close-circle"></mat-icon>
                    </div>
                  </mat-chip>
                }
              </mat-chip-listbox>
            </div>
          </div>
        </div>
      }
      @if (executeDocumentObj.targetType === CommandTargetType.Instance) {
        <div class="col-12 mt-2"
          >
          <mat-form-field appearance="outline">
            <mat-label>Instances</mat-label>
            <cs-select name="target-Instance"
              preventDeselection
              [options]="instanceOptions"
              [(ngModel)]="executeDocumentObj.targetObj.instanceList"
              [multiSelect]="true"
              required/>
          </mat-form-field>
        </div>
      }
      @if (executeDocumentObj.targetType === CommandTargetType.ResourceGroup) {
        <div class="col-12 mt-2"
          >
          <mat-form-field appearance="outline">
            <mat-label>Resource Group</mat-label>
            <cs-select name="target-ResourceGroup"
              preventDeselection
              [options]="resGroupOptions"
              [(ngModel)]="executeDocumentObj.targetObj.resourceGroup"
              [multiSelect]="false"
              required/>
          </mat-form-field>
        </div>
      }
    </div>
  </div>

  <!-- Other Parameters -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Other Parameters</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="col-12 mt-2 row">
      <mat-form-field appearance="outline">
        <mat-label>Comment</mat-label>
        <mat-hint class="fnt-lght">Add a note about the command, if desired.</mat-hint>
        <input matInput
          type="text"
          name="paramComment"
          minlength="1"
          maxlength="127"
          [(ngModel)]="commandRequest.comment"/>
      </mat-form-field>
    </div>
    <div class="col-12 mt-2 row">
      <mat-form-field appearance="outline">
        <mat-label>Timeout (seconds)</mat-label>
        <mat-hint class="fnt-lght">Specify the timeout limit for the command, in seconds.</mat-hint>
        <input matInput
          type="number"
          name="paramTimeout"
          [(ngModel)]="commandRequest.timeout_seconds"/>
      </mat-form-field>
    </div>
  </div>

  <!--Rate Control -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Rate Control </strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="col-12 mt-2 row">
      <div class="col-12 row-display flex-center no-padding">
        <div class="col-6 row-display">
          <p><strong>Concurrency </strong></p>
          <p class="fnt-lght rate-control-option-height">Specify the amount or percentage of targets on which the task will be executed at the same time.</p>
          <mat-radio-group name="concurrency-option"
            [(ngModel)]="executeDocumentObj.concurrencyOption">
            <div class="col-12 row-display no-padding">
              <div class="execute-type-rate-control-option col-6 no-padding">
                <mat-radio-button color="primary"
                  [value]="ConcurrencyOptions.Targets"
                  checked
                class="dsp-flex"></mat-radio-button>
                <mat-form-field appearance="outline"
                  class="mat-field-inp">
                  <mat-label>Targets</mat-label>
                  <input matInput
                    type="number"
                    name="concurrency_target"
                    min="1"
                    step="1"
                    [required]="executeDocumentObj.concurrencyOption === ConcurrencyOptions.Targets"
                    [disabled]="executeDocumentObj.concurrencyOption === ConcurrencyOptions.Percentage"
                    [(ngModel)]="executeDocumentObj.concurrencyTarget"/>
                </mat-form-field>
              </div>
              <div class="execute-type-rate-control-option col-6">
                <mat-radio-button color="primary"
                  [value]="ConcurrencyOptions.Percentage"
                class="dsp-flex"></mat-radio-button>
                <mat-form-field appearance="outline"
                  class="mat-field-inp">
                  <mat-label>Percentage</mat-label>
                  <input matInput
                    type="number"
                    #concurrencyPercentage=ngModel
                    name="concurrency_percentage"
                    min="1"
                    max="100"
                    step="1"
                    [required]="executeDocumentObj.concurrencyOption === ConcurrencyOptions.Percentage"
                    [disabled]="executeDocumentObj.concurrencyOption === ConcurrencyOptions.Targets"
                    [(ngModel)]="executeDocumentObj.maxConcurrencyPercentage"/>
                  @if (concurrencyPercentage.touched && concurrencyPercentage.errors?.max) {
                    <mat-error>
                      The max. percentage allowed is '100'.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </mat-radio-group>
        </div>
        <div class="col-6 row-display border-left-light-gray pl-2">
          <p class="col-12 p-0"><strong>Error Threshold </strong></p>
          <p class="fnt-lght rate-control-option-height">Stop the task after it fails on a specific number of targets.</p>
          <mat-radio-group name="error-option"
            [(ngModel)]="executeDocumentObj.errorsOption">
            <div class="col-12 row-display no-padding ">
              <div class="execute-type-rate-control-option col-6 no-padding">
                <mat-radio-button color="primary"
                  [value]="ErrorOptions.Errors"
                  class="dsp-flex"
                checked></mat-radio-button>
                <mat-form-field appearance="outline"
                  class="mat-field-inp">
                  <mat-label class="fnt-lght">Errors</mat-label>
                  <input matInput
                    type="number"
                    name="errors_value"
                    min="0"
                    step="1"
                    [disabled]="executeDocumentObj.errorsOption === ErrorOptions.Percentage"
                    [required]="executeDocumentObj.errorsOption === ErrorOptions.Errors"
                    [(ngModel)]="executeDocumentObj.maxErrors"/>
                </mat-form-field>
              </div>
              <div class="execute-type-rate-control-option col-6">
                <mat-radio-button color="primary"
                  [value]="ErrorOptions.Percentage"
                class="dsp-flex"></mat-radio-button>
                <mat-form-field appearance="outline"
                  class="mat-field-inp">
                  <mat-label class="fnt-lght">Percentage</mat-label>
                  <input matInput
                    type="number"
                    #errorPercentage=ngModel
                    name="errors_percentage"
                    min="0"
                    max="100"
                    step="1"
                    [disabled]="executeDocumentObj.errorsOption === ErrorOptions.Errors"
                    [required]="executeDocumentObj.errorsOption === ErrorOptions.Percentage"
                    [(ngModel)]="executeDocumentObj.maxErrorsPercentage"/>
                  @if (errorPercentage.touched && errorPercentage.errors?.max) {
                    <mat-error>
                      The max. percentage allowed is '100'.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>

  <!-- Output Options-->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>Output Options</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="col-12 mt-2 no-padding">
      <p class="mat-h4 m-0"><strong>Write the command output to an Amazon S3 bucket.</strong></p>
      <p class="fnt-lght mat-h5">Write all of the command output to an Amazon S3 bucket. In the console, command output is truncated after 24,000 characters.</p>
      <mat-checkbox class="row"
        name="enableS3Bucket"
        color="primary"
        [(ngModel)]="executeDocumentObj.enableS3Bucket"
        (click)="getBucketNames()">Enable an S3 bucket
      </mat-checkbox>
    </div>
    @if (executeDocumentObj.enableS3Bucket) {
      <div class="col-12 mt-2 no-padding"
        >
        <p class="mat-h4 m-0"><strong>S3 bucket name</strong></p>
        <p class="fnt-lght mat-h5 m-0">Specify the S3 bucket where the command output will be stored.</p>
        <div class="col-12 row no-padding">
          <mat-radio-group name="bucketNameType"
            [(ngModel)]="executeDocumentObj.bucketNameType">
            <mat-radio-button color="primary"
              class="dsp-flex"
              [value]="ExecuteCommandBucketNameType.List">Choose an S3 bucket name from the list.
            </mat-radio-button>
            <mat-radio-button color="primary"
              class="dsp-flex"
              [value]="ExecuteCommandBucketNameType.Text">Enter an S3 bucket name in the text box.
            </mat-radio-button>
          </mat-radio-group>
        </div>
        @if (executeDocumentObj.bucketNameType == ExecuteCommandBucketNameType.List) {
          <div class="col-12 row"
            >
            <mat-form-field appearance="outline">
              <cs-select name="bucketNameSelect"
                preventDeselection
                [options]="bucketOptions"
                [(ngModel)]="commandRequest.output_s3_bucket_name"
                [multiSelect]="false"
                required/>
            </mat-form-field>
          </div>
        }
        @if (executeDocumentObj.bucketNameType == ExecuteCommandBucketNameType.Text) {
          <div class="col-12 row"
            >
            <mat-form-field appearance="outline">
              <input matInput
                autocomplete="off"
                type="text"
                name="bucketNameText"
                required
                placeholder="Enter Bucket Name"
                [(ngModel)]="commandRequest.output_s3_bucket_name"/>
            </mat-form-field>
          </div>
        }
        <div class="col-12 row">
          <mat-form-field appearance="outline">
            <mat-label>S3 key prefix- optional</mat-label>
            <mat-hint>You can also send the output to a sub-folder of the S3 bucket. A sub-folder can help you group objects for better organization.</mat-hint>
            <input matInput
              autocomplete="off"
              type="text"
              name="s3keyPrefix"
              [(ngModel)]="commandRequest.output_s3_key_prefix"/>
          </mat-form-field>
        </div>
      </div>
    }

    <div class="col-12 mt-2 no-padding">
      <p class="m-0"><strong>Send command output to Amazon CloudWatch logs.</strong></p>
      <p class="fnt-lght mat-h5">You can stream and encrypt log data for all commands in your account to a log group for CloudWatch Logs in your account.</p>
      <mat-checkbox class="row"
        name="enableCloudWatchLog"
        color="primary"
        [(ngModel)]="commandRequest.cloud_watch_output_config.cloud_watch_output_enabled">Enable
        CloudWatch logs
      </mat-checkbox>
    </div>

    @if (commandRequest.cloud_watch_output_config.cloud_watch_output_enabled) {
      <div class="col-12 mt-2 no-padding"
        >
        <mat-form-field appearance="outline">
          <mat-label>Log group name - Optional</mat-label>
          <mat-hint class="fnt-lght">You can specify the name of your log group. Log groups are groups of log streams that share the same retention, monitoring, and access control settings.
          </mat-hint>
          <input matInput
            autocomplete="off"
            type="text"
            name="cloudWatchLog"
            [(ngModel)]="commandRequest.cloud_watch_output_config.cloud_watch_log_group_name"/>
        </mat-form-field>
      </div>
    }
  </div>

  <!-- SNS Notifications -->
  <div class="document-execution--section mt-2">
    <h3 class="mb-1"><strong>SNS Notifications</strong></h3>
    <mat-divider class="cs-light-border"></mat-divider>
    <div class="col-12 mt-2 no-padding">
      <p class="mat-h4 fnt-lght m-0">Configure AWS Systems Manager to send notifications about command statuses using Amazon Simple Notification Service (SNS).</p>
      <mat-checkbox class="row"
        name="enableSNSNotification"
        (click)="getRoleNames()"
        color="primary"
        [(ngModel)]="executeDocumentObj.enableSnsNotification">
        Enable SNS notifications
      </mat-checkbox>
    </div>
    @if (executeDocumentObj.enableSnsNotification && commandRequest.notification_config) {
      <div class="col-12 mt-2 row no-padding"
        >
        <div class="col-12 row-display">
          <mat-form-field appearance="outline">
            <mat-label>IAM Role</mat-label>
            <mat-hint class="fnt-lght">Choose an IAM role to start SNS notifications</mat-hint>
            <cs-select name="notification_arn"
              preventDeselection
              [options]="roleOptions"
              [(ngModel)]="commandRequest.service_role_arn"
              [multiSelect]="false"
              required/>
          </mat-form-field>
        </div>
        <div class="col-12 row-display mt-2">
          <mat-form-field appearance="outline">
            <mat-label>SNS Topic</mat-label>
            <mat-hint class="fnt-lght">Enter an SNS topic. An SNS topic is a communication channel used to subscribe to notifications.</mat-hint>
            <input matInput
              autocomplete="off"
              type="text"
              name="snsTopic"
              required
              [(ngModel)]="commandRequest.notification_config.arn"/>
          </mat-form-field>
        </div>
        <div class="col-12 row-display mt-2">
          <mat-form-field appearance="outline">
            <mat-label>Event notifications</mat-label>
            <mat-hint class="fnt-lght">Choose the type of events you want to be notified about.</mat-hint>
            <cs-select name="event_notifications"
              preventDeselection
              [options]="notificationOptions"
              [(ngModel)]="commandRequest.notification_config.events"
              [multiSelect]="true"
              required/>
          </mat-form-field>
        </div>
        <div class="col-12 mt-2">
          <p class="mat-h4 m-0"><strong>Change notifications</strong></p>
          <p class="fnt-lght mat-h5 m-0">Choose whether you would like to receive notifications about changes to the 'Run' command.</p>
          <div class="col-12 row no-padding">
            <mat-radio-group name="changeNotificationType"
              [(ngModel)]="commandRequest.notification_config.notification_type">
              <mat-radio-button color="primary"
                class="dsp-flex"
                value="Command">Command status changes
              </mat-radio-button>
              <mat-hint class="ml-5">Notifies you when the status of a command changes.</mat-hint>
              <mat-radio-button color="primary"
                class="dsp-flex"
                value="Invocation">Notifies you when the command status of each instance changes.
              </mat-radio-button>
              <mat-hint class="ml-5">Notifies you when the command status of a single instance changes.</mat-hint>
            </mat-radio-group>
          </div>
        </div>
      </div>
    }
  </div>
</cs-standard-form>
